import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '../../fi-dialogs/fi-dialogs-content-base';
import { INameIdObj } from '../../fi-shared-interfaces';

export interface IChooseBusinessUnitDialogComponentData {
    businessUnits: INameIdObj[];
}

@Component({
    selector: 'fi-choose-business-unit-dialog',
    template: `
        <div class="authenticate-choose-active-unit-description">
          {{ 'user.unit_deactivated_change_message' | fiAppText }}
        </div>
        <mat-select [(value)]="selectedUnit" placeholder="{{ 'common.unit' | fiAppText }}">
          @for (unit of data.businessUnits; track unit) {
            <mat-option [value]="unit">
              {{ unit.Name }}
            </mat-option>
          }
        </mat-select>
        `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./choose-business-unit-dialog.component.scss'],
    host: { class: 'fi-choose-business-unit-dialog' },
    standalone: false,
})
export class ChooseBusinessUnitDialogComponent extends FiDialogsContentBase<
    IChooseBusinessUnitDialogComponentData,
    INameIdObj
> {
    selectedUnit: INameIdObj;

    isYesButtonDisabled() {
        return !this.selectedUnit;
    }

    getResult() {
        return this.selectedUnit;
    }
}
